_ = require 'lodash'

THIRD_PARTY_FACILITY_MWW = 'MWW'
THIRD_PARTY_FACILITY_ARTSADD = 'ARTSADD'
THIRD_PARTY_FACILITY_DTG2GO = 'DTG2GO'
THIRD_PARTY_FACILITY_LASUB = 'LASUB'
THIRD_PARTY_FACILITY_STAKES = 'STAKES'
THIRD_PARTY_FACILITY_TECTONICS = 'TECTONICS'
THIRD_PARTY_FACILITY_YL = 'YL'
THIRD_PARTY_FACILITY_CG = 'CG'
THIRD_PARTY_FACILITY_DTGCSVPARTNERS = 'DTGCSVPARTNERS'
THIRD_PARTY_FACILITY_SAP = 'SAP'
THIRD_PARTY_FACILITY_EPI = 'EPI'
THIRD_PARTY_FACILITY_TECTONICS_API = 'TECTONICS_API'
THIRD_PARTY_FACILITY_DUBOW = 'DUBOW'
LITTLERAYMONDS_FULFILLMENT_INDY = 'LITTLERAYMONDS_FULFILLMENT_INDY'
THIRD_PARTY_FACILITY_SCREENPRINT_PARTNERS = 'SCREENPRINTPARTNERS'
THIRD_PARTY_FACILITY_YOUNGSINC = 'YOUNGSINC'

exports.MAX_CREDIT_LINE = 100000
exports.DEFAULT_ECOMMERCE_QUOTE_QUANTITY = 25

exports.BABY_GARMENT_SIZES = ['3m', '6m', '9m', '12m', '18m', '24m']
exports.GARMENT_SIZES = ["one", "xxsml", "xsml", "sml", "med", "lrg", "xlg", "xxl", "xxxl", "xxxxl", "xxxxxl", "xxxxxxl"].concat(exports.BABY_GARMENT_SIZES)
exports.MUG_SIZES = ["11oz", "15oz"]
exports.ALL_SIZES = exports.GARMENT_SIZES.concat(exports.MUG_SIZES)
exports.SIZE_MAP =
  one: "Custom"
  xxsml: "2XS"
  xsml: "XSM"
  sml: "SML"
  med: "MED"
  lrg: "LRG"
  xlg: "XLG"
  xxl: "2XL"
  xxxl: "3XL"
  xxxxl: "4XL"
  xxxxxl: "5XL"
  xxxxxxl: "6XL"

exports.DISPLAY_SIZE_MAP =
  one: "Custom"
  xxsml: "2XS"
  xsml: "XS"
  sml: "S"
  med: "M"
  lrg: "L"
  xlg: "XL"
  xxl: "2XL"
  xxxl: "3XL"
  xxxxl: "4XL"
  xxxxxl: "5XL"
  xxxxxxl: "6XL"

exports.INFANT_SIZES =
  'xsml': 'NB'
  'sml': '6M'
  'med': '12M'
  'lrg': '18M'
  'xlg': '24M'

exports.TODDLER_SIZES =
  'xsml': '2T'
  'sml': '3T'
  'med': '4T'
  'lrg': '5T'
  'xlg': '6T'
  'xxl': '7T'

exports.GARMENT_ACCESSORY_SIZES =
  'med': 'OS'

# maps Design.type -> Product.type
exports.DESIGN_TYPE_MAP =
  'dtg': 'Garment'
  'screenprint': 'Garment'
  'embr': 'Garment'
  'mug': 'Mug'
  'case': 'Case'
  'poster': 'Poster'
  'socks-short': 'Garment'
  'socks-medium': 'Garment'
  'socks-long': 'Garment'
  'tube-scraf': 'Garment'
  'tie': 'Garment'
  'tote': 'Garment'
  'magnet': 'Magnet'
  'coaster': 'Coaster'
  'pillow-large': 'Pillow'
  'pillow-small': 'Pillow'
  'beach-towel': 'Towel'
  'small-towel': 'Towel'
  'mousepad': 'Mousepad'
  'bracelet-a': 'Jewelry'
  'bracelet-b': 'Jewelry'
  'necklace-a': 'Jewelry'
  'necklace-b': 'Jewelry'
  'necklace-c': 'Jewelry'
  'necklace-d': 'Jewelry'
  'earrings-a': 'Jewelry'
  'earrings-b': 'Jewelry'
  'sublimated-men-crew': 'Garment'
  'sublimated-tank': 'Garment'

exports.AOS_PRODUCT_CATEGORIES = [
  'coaster',
  'cutting-board',
  'necklace',
  'bracelet',
  'earring',
  'magnet',
  'metal-print',
  'mousepad',
  'pillowcase',
  'sock',
  'sandal',
  'scarf',
  'tie',
  'towel'
]

exports.ECOMMERCE = ['shopify', 'wooCommerce']

exports.SUPPORTED_WOO_VER = ['2.2.x', '2.3.x', '2.4.x', '2.5.x']

# Legacy facility list. Kept only for backwards compatibility. Import from oo-components/utils/facility instead
exports.FACILITIES = [
  'FRESNO',
  'SCRANTON',
  'INDY',
  'DALLAS',
  'FREMONT',
  THIRD_PARTY_FACILITY_MWW,
  THIRD_PARTY_FACILITY_ARTSADD,
  THIRD_PARTY_FACILITY_CG,
  THIRD_PARTY_FACILITY_DTG2GO,
  THIRD_PARTY_FACILITY_LASUB,
  THIRD_PARTY_FACILITY_SAP
  THIRD_PARTY_FACILITY_STAKES,
  THIRD_PARTY_FACILITY_TECTONICS,
  THIRD_PARTY_FACILITY_YL,
  THIRD_PARTY_FACILITY_DTGCSVPARTNERS,
  THIRD_PARTY_FACILITY_EPI,
  THIRD_PARTY_FACILITY_DUBOW,
  LITTLERAYMONDS_FULFILLMENT_INDY,
  THIRD_PARTY_FACILITY_TECTONICS_API,
  THIRD_PARTY_FACILITY_SCREENPRINT_PARTNERS,
  THIRD_PARTY_FACILITY_YOUNGSINC,
]

exports.ROLES =
  NONE: -1 # No login required
  USER: 0 # Normal user
  EMPLOYEE: 1 # Normal employee
  MANAGE: 6
  ADMIN: 11 # Admin user

exports.GROUP =
  'ADMIN': 1
  'PRODUCTION': 1
  'SALES': 1
  'CS': 1

exports.FACILITY_SHORT_CODES =
  INDY: "IN"
  FREMONT: "FR"
  SCRANTON: "PA"
  FRESNO: "CA"
  DALLAS: "TX"
  FR: "FREMONT"
  IN: "INDY"
  PA: "SCRANTON"
  CA: "FRESNO"
  TX: "DALLAS"
  MWW: THIRD_PARTY_FACILITY_MWW
  ARTSADD: THIRD_PARTY_FACILITY_ARTSADD
  CG: THIRD_PARTY_FACILITY_CG
  DTG2GO: THIRD_PARTY_FACILITY_DTG2GO
  YL: THIRD_PARTY_FACILITY_YL
  STAKES: THIRD_PARTY_FACILITY_STAKES
  TECTONICS: THIRD_PARTY_FACILITY_TECTONICS
  LASUB: THIRD_PARTY_FACILITY_LASUB
  DTGCSVPARTNERS: THIRD_PARTY_FACILITY_DTGCSVPARTNERS
  SAP: THIRD_PARTY_FACILITY_SAP
  EPI: THIRD_PARTY_FACILITY_EPI
  DUBOW: THIRD_PARTY_FACILITY_DUBOW
  LITTLERAYMONDSINDY: LITTLERAYMONDS_FULFILLMENT_INDY
  TECTONICS_API: THIRD_PARTY_FACILITY_TECTONICS_API
  SCREENPRINTPARTNERS: THIRD_PARTY_FACILITY_SCREENPRINT_PARTNERS
  YOUNGSINC: THIRD_PARTY_FACILITY_YOUNGSINC


exports.COMPANIES = ['fuel-pod', 'inkpop', 'scalable-press', 'teechip',
  'plutocase', 'sl-wholesale', 'sl-retail', 'fanmall', 'photos']

exports.PRINT_LOCATION = ['center', 'center-left', 'center-right', 'left-pocket', 'right-pocket', 'bottom', 'bottom-left', 'bottom-right', 'top-left', 'top-right']

exports.PRINTER_PROBLEMS = [
  'missing garment'
  'flawed garments'
  'wrong artwork used'
  'missing print'
  'ink colors'
  'print detail loss'
  'print placement'
  'print size'
  'print quality'
  'stains'
  'curing issue'
  'personalization'
  'packing issue'
  'wrong address'
  'late delivery'
]

exports.CLAIM_REASONS  = [
  'order not delivered'
  'late delivery'
  'missing items'
  'wrong items'
  'misprinted/flawed items'
  'other'
]

exports.TAG_EXCLUSIONS =
  'polyester': 'dtg'
  'dtg-banned': 'dtg'
  'screenprint-banned': 'screenprint'

exports.TAG_WARNINGS =
  'dtg-warn': 'dtg'

exports.UPDATER_SERVICES = [
  'oo-printer'
  'sp-ping'
  'oo-webcam'
  'oo-pretreat'
  'oo-pretreat2'
  'oo-dtg/rip'
  'oo-dtg/upload'
  'oo-artwork/consume'
  'oo-fingerprint'
  'sp-embr-server'
]

exports.INTERNAL_PROBLEMS = [
  (
    problem: 'incorrect information given to customer'
    division: 'customer service'
  )
  (
    problem: 'incorrect charge or refund'
    division: 'customer service'
  )
  (
    problem: 'incorrect preview image update'
    division: 'customer service'
  )
  (
    problem: 'incorrect holds issue resolution'
    division: 'customer service'
  )
  (
    problem: 'incorrect internal notes'
    division: 'customer service'
  )
  (
    problem: 'incorrect delivery data adjustment'
    division: 'customer service'
  )
  (
    problem: 'forgot to take order off hold'
    division: 'customer service'
  )
  (
    problem: 'forgot charge or refund'
    division: 'customer service'
  )
  (
    problem: 'forgot preview image update'
    division: 'customer service'
  )
  (
    problem: 'forgot holds issue resolution'
    division: 'customer service'
  )
  (
    problem: 'forgot internal notes'
    division: 'customer service'
  )
  (
    problem: 'forgot delivery date adjustment'
    division: 'customer service'
  )
  (
    problem: 'cancellation without approval'
    division: 'customer service'
  )
  (
    problem: 'mishandled customer interaction'
    division: 'customer service'
  )
  (
    problem: 'other'
    division: 'customer service'
  )
  (
    problem: 'incorrect holds assignment'
    division: 'approve order'
  )
  (
    problem: 'incorrect printer assignment'
    division: 'approve order'
  )
  (
    problem: 'incorrect dimensions/placement'
    division: 'approve order'
  )
  (
    problem: 'other'
    division: 'approve order'
  )
  (
    problem: 'incorrect text'
    division: 'approve artwork'
  )
  (
    problem: 'incorrect colors'
    division: 'approve artwork'
  )
  (
    problem: 'incorrect images'
    division: 'approve artwork'
  )
  (
    problem: 'other'
    division: 'approve artwork'
  )
]

exports.SEVERITY = [
  'minor'
  'medium'
  'significant'
  'devastating'
]

exports.BLANK_SUPPLIERS = ['ALPHA', 'BODEK', 'CUTTER', 'HERITAGE', 'SANMAR', 'SS', 'TSC', 'INVENTORY', 'SUPPLEMENTARY', 'EXTRACTOR', 'DROPOFF']
exports.ACTIVE_BLANK_SUPPLIERS = ['ALPHA', 'SANMAR', 'SS']

exports.TRUCK_LINES =
  DALLAS: [
    {supplier: 'ALPHA', warehouse: 'TD'}
    {supplier:'SS', warehouse: 'TX'}
  ]
  INDY: [
    {supplier:'ALPHA', warehouse:'CC'} # CC: Chicago
    {supplier:'SS', warehouse: 'IL'}
  ]
  SCREENPRINTPARTNERS: []
  FREMONT: []
  SCRANTON: []
  FRESNO: []

exports.PRINTER_ZIP =
  'FRESNO': '93725'
  'FREMONT': '94538'
  'INDY': '46226'
  'SCRANTON': '18507'
  'DALLAS': '75019'
  'LITTLERAYMONDS_FULFILLMENT_INDY': '46226'

exports.FACILITY_FULL_NAME =
  INDY: "Indianapolis, IN"
  FREMONT: "Fremont, CA"
  SCRANTON: "Scranton, PA"
  FRESNO: "Fresno, CA"
  DALLAS: "Dallas, TX"

exports.TIMEZONES =
  INDY: 'America/Indiana/Indianapolis'
  FREMONT: 'America/Los_Angeles'
  FRESNO: 'America/Los_Angeles'
  SCRANTON: 'America/New_York'
  DALLAS: 'America/Chicago'

exports.INVENTORY_CHECKPOINTS =
  ORDER_CREATED: "order created"
  ORDERPART_CREATED: "order part created"
  STOCK_UPDATE: "stock update"
  ORDER_ACCEPTED: "order accepted"

exports.ROUTER_GROUPING_PREFERENCES = ['cheapest', 'fastest']

# TECH-DEBT Create a DTG_SIDES so DtgRips continue working as expected.
exports.PRINT_SIDES = [
  'front',
  'back',
  'right',
  'left',
  'sleeve-left',
  'sleeve-right',
  'hat-left',
  'hat-right',
  'outside-left',
  'outside-right',
  'inside-left',
  'inside-right'
]

exports.EMBR_SIDES = ['front', 'front-left', 'front-right', 'back', 'right', 'left']

exports.GARMENT_ARTWORK_SIZES =
  front:
    'standard':
      width: 14
      height: 16
    'small':
      width: 10
      height: 12
    'pocket':
      width: 10
      height: 10
    'youth-pocket':
      width: 10
      height: 6
  back:
    'standard':
      width: 14
      height: 16
    'small':
      width: 10
      height: 12
    'pocket':
      width: 14
      height: 16
    'youth-pocket':
      width: 10
      height: 12
  left:
    'standard':
      width: 4
      height: 4
  right:
    'standard':
      width: 4
      height: 4

exports.PRINT_TYPES =
  Screenprint: "Screenprint"
  DTG_Print: "DTG Print"
  CASE: "Case"
  MUG: "Mug"
  POSTER: "Poster"

AOS_DESIGN_TYPES = [
  'socks-short',
  'socks-medium',
  'socks-long',
  'tube-scarf',
  'tie',
  'tote',
  'magnet',
  'coaster',
  'pillow-large',
  'pillow-small',
  'beach-towel',
  'small-towel',
  'mousepad',
  'bracelet-a',
  'bracelet-b',
  'necklace-a',
  'necklace-b',
  'necklace-c',
  'necklace-d',
  'earrings-a',
  'earrings-b'
]

DESIGN_TYPES = [
  'screenprint',
  'dtg',
  'case',
  'mug',
  'poster',
  'embr',
].concat(AOS_DESIGN_TYPES)

exports.AOS_DESIGN_TYPES = AOS_DESIGN_TYPES
exports.DESIGN_TYPES = DESIGN_TYPES

exports.PRODUCT_TYPES = ['Garment', 'Case', 'Mug', 'Poster', 'Jewelry', 'Housewares', 'Accessories', 'Footwear', 'ThirdParty']

exports.PRODUCT_PRINT_TYPES = [
  'screenprint',
  'dtg',
  'sublimation',
  'poster',
  'embr'
]

exports.PRODUCT_TYPE_TO_DESIGN_TYPE =
  Garment: ['screenprint', 'dtg', 'embr']
  Case: ['case']
  Mug: ['mug']
  Poster: ['poster']


exports.CARRIER = CARRIER =
  UPS: 'UPS'
  USPS: 'USPS'
  FEDEX: 'FEDEX'
  DHL: 'DHLGM'

exports.SHIPPING_ESTIMATES = SHIPPING_ESTIMATES =
  '01': '(1 day)'
  '13': '(1 day)'
  '02': '(2 days)'
  '12': '(3 days)'
  '03': '(1-5 days)'
  '3313': '(3-8 days)'
  '3316': '(3-8 days)'
  'US-PMI': '(6-10 days)'
  'US-FCI': '(7-21 days)'
  'US-XM': '(2 days)'
  'US-PM': '(1-3 days)'
  'US-PS': '(2-8 days)'
  'US-FC': '(1-5 days) [13 oz max.]'
  'standard': '(3-8 days)'
  'WILLCALL': 'willcall n/a'

exports.STANDARD_RANGE = STANDARD_RANGE = [3, 8]

exports.SHIPPING_RANGES = SHIPPING_RANGES =
  '01': [1]
  '13': [1]
  '02': [2]
  '12': [3]
  '03': [1, 5]
  '3313': STANDARD_RANGE
  '3316': STANDARD_RANGE
  'US-PMI': [6, 10]
  'US-FCI': [7, 21]
  'US-XM': [2]
  'US-PM': [1, 3]
  'US-PS': [2, 8]
  'US-FC': [1, 5]

exports.SERVICE_TO_CODE = SERVICE_TO_CODE =
  "UPS-GND": '03'
  "UPS-1DA": '01'
  "UPS-3DS": '12'
  "UPS-2DA": '02'
  "WILLCALL": 'WILLCALL'

exports.SERVICES = SERVICES =
  'standard':
    description: 'Standard Shipping'
  '01':
    description: 'UPS Next Day Air'
    carrier: CARRIER.UPS
  '02':
    description: 'UPS 2-Day Air'
    carrier: CARRIER.UPS
  '03':
    description: 'UPS Ground'
    carrier: CARRIER.UPS
  '07':
    description: 'UPS Worldwide Express'
    carrier: CARRIER.UPS
  '08':
    description: 'UPS Worldwide Express Expedited'
    carrier: CARRIER.UPS
  '11':
    description: 'UPS Standard'
    carrier: CARRIER.UPS
  '12':
    description: 'UPS 3-Day Select'
    carrier: CARRIER.UPS
  '13':
    description: 'UPS Next Day Air Saver'
    carrier: CARRIER.UPS
  '14':
    description: 'UPS Next Day Air AM'
    carrier: CARRIER.UPS
  '54':
    description: 'UPS Worldwide Express Plus'
    carrier: CARRIER.UPS
  '59':
    description: 'UPS 2-Day Air AM'
    carrier: CARRIER.UPS
  '65':
    description: 'UPS Saver'
    carrier: CARRIER.UPS
  '92':
    description: 'UPS SurePost < 1LB'
    carrier: CARRIER.UPS
  '93':
    description: 'UPS SurePost > 1LB'
    carrier: CARRIER.UPS
  'US-FC':
    description: "USPS First Class"
    carrier: CARRIER.USPS
  #'US-MM':
  #  description: "USPS Media Mail"
  #  carrier: CARRIER.USPS
  'US-PP':
    description: "USPS Parcel Post"
    carrier: CARRIER.USPS
  'US-PM':
    description: "USPS Priority Mail"
    carrier: CARRIER.USPS
  'US-PS':
    description: "USPS Parcel Select"
    carrier: CARRIER.USPS
  'US-XM':
    description: "USPS Express Mail"
    carrier: CARRIER.USPS
  'US-EMI':
    description: "USPS Express Mail International"
    carrier: CARRIER.USPS
  'US-PMI':
    description: "USPS Priority Mail International"
    carrier: CARRIER.USPS
  'US-FCI':
    description: "USPS First Class International"
    carrier: CARRIER.USPS
  '3313':
    description: 'DHL Smartmail Parcel Expedited'
    carrier: CARRIER.DHL
    max: 1
    whitelist: ['US']
  '3314':
    description: 'DHL Smartmail Parcel'
    carrier: CARRIER.DHL
    max: 1
    whitelist: ['US']
  '3315':
    description: 'DHL Smartmail Parcel Plus'
    carrier: CARRIER.DHL
    min: 1
    whitelist: ['US']
  '3316':
    description: 'DHL Smartmail Parcel Plus Expedited'
    carrier: CARRIER.DHL
    min: 1
    whitelist: ['US']
  '3359':
    description: 'DHL GM Packet Plus'
    carrier: CARRIER.DHL
    blacklist: ['US']
  '3360':
    description: 'DHL GM Packet Plus Large'
    carrier: CARRIER.DHL
    blacklist: ['US']
  '3363':
    description: 'DHL GM Packet Priority'
    carrier: CARRIER.DHL
    blacklist: ['US']
  '3365':
    description: 'DHL GM Parcel Priority'
    carrier: CARRIER.DHL
    blacklist: ['US']
  'FDX-FO':
    description: 'FedEx First Overnight'
    carrier: CARRIER.FEDEX
    whitelist: ['US']
  'FDX-PO':
    description: 'FedEx Priority Overnight'
    carrier: CARRIER.FEDEX
    whitelist: ['US']
  'FDX-SO':
    description: 'FedEx Standard Overnight'
    carrier: CARRIER.FEDEX
    whitelist: ['US']
  'FDX-2DA':
    description: 'FedEx 2-Day AM'
    carrier: CARRIER.FEDEX
    whitelist: ['US']
  'FDX-2D':
    description: 'FedEx 2-Day'
    carrier: CARRIER.FEDEX
    whitelist: ['US']
  'FDX-ES':
    description: 'FedEx Express Saver'
    carrier: CARRIER.FEDEX
    whitelist: ['US']
  'FDX-GND':
    description: 'FedEx Ground'
    carrier: CARRIER.FEDEX
    whitelist: ['US']
  'WILLCALL':
    description: 'Custom Willcall'
    carrier: 'None'

exports.SHIPPING_BULK_LIMIT = 20
exports.DTG_SHIPPING_BULK_LIMIT = 72
exports.SHIPPING_SPLIT_LIMIT = 10
exports.MARSHAL_BIN_LIMIT = 72

PRINTERS =
  INDY:
    address:
      name: 'Little Raymonds Print Shop'
      address1: '2900 N Shadeland Ave'
      address2: 'Ste B1'
      city: 'Indianapolis'
      state: 'IN'
      zip: '46219'
    types:
      'dtg': true
      'screenprint': true
      'mug': true
      #'case': true
  FRESNO:
    address:
      name: 'Little Raymonds Print Shop'
      address1: '2904 S Angus Ave'
      city: 'Fresno'
      state: 'CA'
      zip: '93725'
    types:
      'screenprint': true
  SCRANTON:
    address:
      name: 'Little Raymonds Print Shop'
      address1: '510 Gleason Rd'
      city: 'Moosic'
      state: 'PA'
      zip: '18507'
    types:
      'dtg': true
      'screenprint': true
      #'mug': true
      #'case': true
  FREMONT:
    address:
      name: 'Little Raymonds Print Shop'
      address1: '41455 Christy St'
      city: 'Fremont'
      state: 'CA'
      zip: '94538'
    types:
      'case': true
      'poster': true
  DALLAS:
    address:
      name: 'Little Raymonds Print Shop'
      address1: '850 Northlake Dr'
      address2: 'Suite 500'
      city: 'Coppell'
      state: 'TX'
      zip: '75019'
    types: {}

PRINTERS[THIRD_PARTY_FACILITY_MWW] =
  address:
    name: 'Little Raymonds Print Shop'
    address1: '7800 Records Street'
    address2: 'Suite C'
    city: 'Indianapolis'
    state: 'IN'
    zip: '46226'
  types: {}

PRINTERS[THIRD_PARTY_FACILITY_ARTSADD] =
  address:
    name: 'Little Raymonds Print Shop'
    address1: '7800 Records Street'
    address2: 'Suite C'
    city: 'Indianapolis'
    state: 'IN'
    zip: '46226'
  types: {}

PRINTERS[THIRD_PARTY_FACILITY_DTG2GO] =
  address:
    name: 'Little Raymonds Print Shop'
    address1: '7800 Records Street'
    address2: 'Suite C'
    city: 'Indianapolis'
    state: 'IN'
    zip: '46226'
  types: {}

PRINTERS[LITTLERAYMONDS_FULFILLMENT_INDY] =
  address:
    name: 'Little Raymonds Print Shop'
    address1: '7800 Records Street'
    address2: 'Suite C'
    city: 'Indianapolis'
    state: 'IN'
    zip: '46226'
  types: {}

PRINTERS[THIRD_PARTY_FACILITY_YL] =
  address:
    name: 'Little Raymonds Print Shop'
    address1: '7800 Records Street'
    address2: 'Suite C'
    city: 'Indianapolis'
    state: 'IN'
    zip: '46226'
  types: {}

PRINTERS[THIRD_PARTY_FACILITY_STAKES] =
  address:
    name: 'Little Raymonds Print Shop'
    address1: '7800 Records Street'
    address2: 'Suite C'
    city: 'Indianapolis'
    state: 'IN'
    zip: '46226'
  types: {}

PRINTERS[THIRD_PARTY_FACILITY_TECTONICS] =
  address:
    name: 'Little Raymonds Print Shop'
    address1: '7800 Records Street'
    address2: 'Suite C'
    city: 'Indianapolis'
    state: 'IN'
    zip: '46226'
  types: {}

PRINTERS[THIRD_PARTY_FACILITY_LASUB] =
  address:
    name: 'Little Raymonds Print Shop'
    address1: '7800 Records Street'
    address2: 'Suite C'
    city: 'Indianapolis'
    state: 'IN'
    zip: '46226'
  types: {}

PRINTERS[THIRD_PARTY_FACILITY_CG] =
  address:
    name: 'Little Raymonds Print Shop'
    address1: '7800 Records Street'
    address2: 'Suite C'
    city: 'Indianapolis'
    state: 'IN'
    zip: '46226'
  types: {}

PRINTERS[THIRD_PARTY_FACILITY_SAP] =
  address:
    name: 'Little Raymonds Print Shop'
    address1: '7800 Records Street'
    address2: 'Suite C'
    city: 'Indianapolis'
    state: 'IN'
    zip: '46226'
  types: {}

PRINTERS[THIRD_PARTY_FACILITY_DTGCSVPARTNERS] =
  address:
    name: 'Little Raymonds Print Shop'
    address1: '7800 Records Street'
    address2: 'Suite C'
    city: 'Indianapolis'
    state: 'IN'
    zip: '46226'
  types: {}

PRINTERS[THIRD_PARTY_FACILITY_SCREENPRINT_PARTNERS] =
  address:
    name: 'Little Raymonds Print Shop'
    address1: '7800 Records Street'
    address2: 'Suite C'
    city: 'Indianapolis'
    state: 'IN'
    zip: '46226'
  types: {}

PRINTERS[THIRD_PARTY_FACILITY_EPI] =
  address:
    name: 'Little Raymonds Print Shop'
    address1: '7800 Records Street'
    address2: 'Suite C'
    city: 'Indianapolis'
    state: 'IN'
    zip: '46226'
  types: {}

#TODO Remove all this duplicated code and create one address that can be reused by all 3rd Parties
PRINTERS[THIRD_PARTY_FACILITY_DUBOW] =
  address:
    name: 'Fulfillment Center'
    address1: '7800 Records Street'
    address2: 'Suite C'
    city: 'Indianapolis'
    state: 'IN'
    zip: '46226'
  types: {}

PRINTERS[THIRD_PARTY_FACILITY_TECTONICS_API] =
  address:
    name: 'Little Raymonds Print Shop'
    address1: '7800 Records Street'
    address2: 'Suite C'
    city: 'Indianapolis'
    state: 'IN'
    zip: '46226'
  types: {}

PRINTERS[THIRD_PARTY_FACILITY_YOUNGSINC] =
  address:
    name: 'Little Raymonds Print Shop'
    address1: '7800 Records Street'
    address2: 'Suite C'
    city: 'Indianapolis'
    state: 'IN'
    zip: '46226'
  types: {}


exports.PRINTERS = PRINTERS

exports.BULB_POWERS = [
  { display: '10%', value: 10 },
  { display: '20%', value: 20 },
  { display: '30%', value: 30 },
  { display: '40%', value: 40 },
  { display: '50%', value: 50 },
  { display: '60%', value: 60 },
  { display: '70%', value: 70 },
  { display: '80%', value: 80 },
  { display: '90%', value: 90 },
  { display: '100%', value: 100 },
];

exports.BULB_ZONES = {
  zone1: [0..2],
  zone2: [3..5],
  zone3: [6..26],
  MIN: 0,
  MAX: 100,
  DEFAULT: 100,
  SIZE: 27 # 9 columns of 3 bulb rows
};

exports.POSTER_STATUS =
  created: 'created'
  ripping: 'ripping'
  uploaded: 'uploaded'
  ripped: 'ripped'
  downloaded: 'downloaded'
  printed: 'printed'
  qced: 'qced'

exports.PRINTER_STATUS = [
  'printing'
  'out-of-service'
]

exports.DEPARTMENTS = [
  'screenprint',
  'dtg',
  'shipping/receiving',
  'digital/sublimation',
  'embroidery',
  'non production'
  ]

exports.POSITIONS = [
  # Sales
  'BDR Rep'
  'AR Rep'
  'Sales Supervisor'
  # CS
  'CS Rep'
  'Approval Rep'
  'Procurement Rep'
  'Claim Rep'
  'CS Supervisor'
  # Warehouse
  'Supervisor'
  'Screenprint Press Operator'
  'Screenprint QC'
  'Screenprint Press Assistant'
  'Screenprint Picker'
  'Screen Reclaim'
  'Screen Coater'
  'Screen Prep'
  'Screen Washout'
  'Screen Taper'
  'DTG Lead'
  'DTG Printer'
  'DTG Pretreater'
  'DTG Heat Presser'
  'DTG QC'
  'DTG Picker'
  'Shipping Lead'
  'Shipping Associate'
  'Shipping Racker'
  'Shipping Marshaler'
  'Receiving Lead'
  'Receiving Associate'

  'Engineer'
  'Designer'
  'QA Engineer'

  'Other'
  'Non Production'
]


exports.SUPERVISOR_POSITIONS = [
  'Sales Supervisor'
  'CS Supervisor'
  'Supervisor'
]

exports.PRODUCT_TEMPLATES =
  'gildan-cotton-t-shirt':
    'front': 'men-tshirt-front'
  'canvas-unisex-t-shirt':
    'front': 'men-tshirt-front'

exports.FINGERPRINT_SAMPLE_NUMBER = 4

exports.FINGERPRINT_S3_PATH = '/fingerprints'

exports.CRM_ACTIVITY_TYPE = [
  "email"
  "phone"
]

exports.CRM_ACTIVITY_PURPOSE = [
  "introduction"
  "pricing"
  "demo"
  "follow up"
  "other"
  "customer service call"
  "left message"
  "invalid number"
  "invalid email"
  "contacted"
]

module.exports.STATUS_LOG_ACTIONS =
  dtg:
    'inventory-receiving-sticker': 'RECEIVED'
    'blank-received': 'RECEIVED'
    'dtg-artwork-not-ready':'RIP_ISSUE'
    'dtg-print-rip-down': 'RIP_ISSUE'
    'dtg-print-not-ready': 'RIP_ISSUE'
    'pretreat-fetch': 'PRETREAT'
    'dtg-print-complete': 'PRINT'
    'qc-fetch': 'QC'
    'rack-qc-store': 'STORED'
    'dtg-cart': 'CART_LOADED'
  screenprint:
    'inventory-receiving-sticker': 'RECEIVED'
    'first-store': 'STORED'
    'rack-screenprint-store': 'STORED'
    'rack-exception-store': 'STORED'
  mug:
    'mug-taped': 'PRINTED'
    'rack-qc-store': 'STORED'
  case:
    'rack-exception-store': 'STORED'
  poster: {}
  embr: {}

module.exports.SUGGESTED_SWAP_SETTING =
  '2000': ['5000', '3931', 'HD6R', '363']
  '2001': ['3001C', '3600', 'N6210']
  '2400': ['4930', 'G540']
  '3931': ['HD6R', '363', '5250', '5280', '2000', '5000']
  '5000': ['2000', '3931', 'HD6R', '363']
  '5250': ['5280', '3931', 'HD6R', '363', '2000', '5000']
  '18500': ['996M', 'P170']
  '3931B': ['363B', '5450', '2000B', '5000B']
  '5000B': ['3931B', '2000B', '5450', '363B']
  '2000L': ['L3930R']
  '39VR': ['G64V', '982']
  '2102': ['6004', '3900']
  'L3930R': ['2000L']
  '18000': ['562', 'P1607']
  '4930': ['G540']
  '39TKR': ['2200']

module.exports.MILESTONE_TIMELINE =
  'dtg': [
    {milestone: 'IMPORTED', max: 5 * 24, average: 12}
    {milestone: 'REJECTION', max: 5 * 24, average: 12, occasional: true}
    {milestone: 'BLANK_ORDERED', max: 7 * 24, average: 48}
    {milestone: 'RECEIVED', max: 7 * 24, average: 12}
    {milestone: 'CART_LOADED', max: 5 * 24, average: 24}
    {milestone: 'RIP_ISSUE', max: 5 * 24, average: 48, alert: true, occasional: true}
    {milestone: 'PRETREAT', max: 3 * 24, average: 2, occasional: true}
    {milestone: 'PRINT', max: 3 * 24, average: 1}
    {milestone: 'QC', max: 3 * 24, average: 1}
    {milestone: 'STORED', max: 5 * 24, average: 6}
    {milestone: 'SHIPPED'}
  ]
  'screenprint': [
    {milestone: 'IMPORTED', max: 5 * 24, average: 12}
    {milestone: 'REJECTION', max: 5 * 24, average: 12, occasional: true}
    {milestone: 'BLANK_ORDERED', max: 7 * 24, average: 48}
    {milestone: 'RECEIVED', max: 7 * 24, average: 24}
    {milestone: 'STORED', max: 7 * 24, average: 6}
    {milestone: 'SHIPPED'}
  ]
  'mug': [
    {milestone: 'IMPORTED', max: 5 * 24, average: 36}
    {milestone: 'REJECTION', max: 5 * 24, average: 12, occasional: true}
    {milestone: 'PRINTED', max: 3 * 24, average: 3}
    {milestone: 'STORED', max: 7 * 24, average: 3}
    {milestone: 'SHIPPED'}
  ]
  'case': [
    {milestone: 'IMPORTED', max: 15 * 24, average: 36}
    {milestone: 'REJECTION', max: 5, average: 12, alert: true, occasional: true}
    {milestone: 'STORED', max: 7 * 24, average: 3}
    {milestone: 'SHIPPED'}
  ]
  'poster': [
    {milestone: 'IMPORTED', max: 15 * 24, average: 84}
    {milestone: 'REJECTION', max: 5 * 24, average: 84, alert: true, occasional: true}
    {milestone: 'SHIPPED'}
  ]

exports.SCREENPRINT_SIZING_RULES =
  standard: {front: {width: 14, height: 16}, back: {width: 14, height: 16}}
  small: {front: {width: 10, height: 12}, back: {width: 10, height: 12}}
  pocket: {front: {countPlacement: true, width: 14, height: 10}, back: {width: 14, height: 16}}
  'youth-pocket': {front: {countPlacement: true, width: 10, height: 8}, back: {width: 10, height: 12}}
  chest: {front: {width: 14, height: 4}, back: {width: 14, height: 16}}
  zipper: {front: {width: 14, height: 4}, back: {width: 14, height: 16}}

exports.DOMESTIC_COUNTRIES = ['PR', 'VI', 'GU', 'AA', 'AP', 'US']
exports.EU_COUNTRIES = [
  'AT' # Austria
  'BE' # Belgium
  'BG' # Bulgaria
  'HR' # Croatia
  'CY' # Cyprus
  'CZ' # Czechia
  'DK' # Denmark
  'EE' # Estonia
  'FI' # Finland
  'FR' # France
  'DE' # Germany
  'GR' # Greece
  'HU' # Hungary
  'IE' # Ireland
  'IT' # Italy
  'LV' # Latvia
  'LT' # Lithuania
  'LU' # Luxembourg
  'MT' # Malta
  'NL' # Netherlands
  'PL' # Poland
  'PT' # Portugal
  'RO' # Romania
  'SK' # Slovakia
  'SI' # Slovenia
  'ES' # Spain
  'SE' # Sweden
]

# https://app.asana.com/0/319191434854776/506528148344293
# yarn upgraded in oo-artwork, oo-print, sp-order/sp-product-picker
exports.SCREENPRINT_COLOR_LIMIT = 8
exports.EMBR_COLOR_LIMIT = 15

exports.OOSHIRTS_USER_ID = '57a26d2a7470cb473a565dae'


exports.ORDER_STATUS = ORDER_STATUS =  [
  'quote'             # Quote complete
  'order'             # User has completed order, not processed
  'validated'         # Designs has been validated and ready to progress
  'unpaid'            # Not enough funds to process order
  'paid'              # Order paid
  'on-hold'           # Order has been put on hold by CS
  'artwork-created'   # Screenprint artwork has been created
  'printing'          # Order received by production
  'shipped'           # Order shipped
  'cancelled'         # Order cancelled
]


exports.ITEM_STATUS = ITEM_STATUS = ORDER_STATUS.concat [
  'reprint'           # OrderPart
]

exports.EVENT_STATUS = EVENT_STATUS = ITEM_STATUS.concat [
  'garment-substitution' # Garment has been substituted
  'address-changed' # Order shipping address changed
  'returned'      # Shipment returned
  'delivered'     # Shipment delivered
  'printing-email'
  'order-cancelled-email'
  'order-confirm-email'
  'order-shipped-email'
  'order-invoice-email'
  'shipment-returned-email'
  'order-on-hold-email'
  'order-artwork-created-email'
  'order-approval-delayed-email'
  'artwork-preparation' # OrderForm
  'artwork-on-hold'   # OrderForm
  'order-on-hold'     # OrderForm
  'artwork-complete'  # OrderForm
  'order-approved'    # OrderForm
  'blanks-placed'     # OrderPart
  'blanks-received'   # OrderPart ... these are probably not used
  'pretreat'          # OrderPart
  'printed'           # OrderPart or OrderForm
  'taped'             # OrderPart
  'baked'             # OrderPart
  'qc'                # OrderPart or OrderForm
  'stored'            # OrderPart
  'rejection'         # OrderPart
  'ripped'            # OrderPart
  'stitch'            # OrderPart
  # New for alpha
  'on-hold'           # Order has been put on hold by CS
  'screenprintable-cs-approved'
  'screenprintable-cs-rejected'
  'address-auto-approved'
  'address-auto-rejected'
  'address-cs-approved'
  'address-cs-rejected'
  'ip-auto-approved'
  'ip-auto-unresolved'
  'ip-auto-rejected'
  'ip-cs-approved'
  'ip-cs-rejected'
  'artwork-draft'     # Artwork team has created artwork
  'artwork-qc-approve'# Artwork qc has approved of created artwork
  'artwork-qc-reject' # Artwork qc has rejected created artwork
  'artwork-created'   # Artwork has been qcd
  'user-approved'     # User has approved created artwork
  'user-rejected'     # User has rejected created artwork
  'change-request'    # User has requested an order change
  'cs-approved'       # Order has been approved by customer service
  'user-cs-request'   # User has requested customer service change
  'order-released'    # Order released for printing by AlphaBroder
  'blanks-arrived'
  'blanks-shipped'
  'screens-made'
  'on-press'
  'personalization-complete'
  'qc-defects'
  'qc-complete'
  'order-name-changed' # User has requested change to order name/PO
  'shipping-method-changed' # User has requested change to shipping method
  'design-change' # Modification to design colors/dimensions/placement
  'partial-receipt' # Warehouse receives partial blanks shipment
  'reassigned' # Reassigned facilities
  'reassigned-facility' # Reassigned facilities
]

# Artwork handling, oo-print artwork APi etc.
# Validate artwork for artwork API
#   alias: Other file extensions that apply
#   ids: ImageMagic recognition. See https://www.imagemagick.org/script/formats.php
exports.ARTWORK_API_FORMATS =
  # Raster
  'png': {ids: ['PNG', 'PNG8', 'PNG24', 'PNG32'], type: 'raster'}
  'jpg': {alias: ['jpeg'], ids: ['JPEG'], type: 'raster'}
  'gif': {ids: ['GIF'], type: 'raster'}
  'bmp': {ids: ['BMP', 'BMP2', 'BMP3'], type: 'raster'}
  'ico': {ids: ['ICO'], type: 'raster'}
  'jp2': {ids: ['JP2'], type: 'raster'}
  # Vector
  'eps': {ids: ['PS', 'EPT', 'EPS', 'EPS2', 'EPS3'], type: 'vector'}
  'svg': {ids: ['SVG'], type: 'vector'}
  'pdf': {alias: ['ai'], ids: ['PPM', 'PDF'], type: 'vector'}
  'dst': {ids: ['DST'], type: 'vector'}


_exts = []
for ext, {alias} of exports.ARTWORK_API_FORMATS
  _exts.push ext
  if alias
    _exts.push alias...
exports.ARTWORK_API_EXTENSIONS = _exts


exports.PROMO_EMAILS_TEMPLATES = [
  'inactivity-follow-up'
  'new-user-follow-up'
]

exports.SUBLIMATION_COLORS = [{
  hex: 'F6F6F6'
  name: 'White'
}, {
  hex: '000000'
  name: 'Black'
}, {
  hex: 'CCCCCC'
  name: 'Ash'
}, {
  hex: '999999'
  name: 'Athletic Heather'
}, {
  hex: '595959'
  name: 'Charcoal Grey'
}, {
  hex: '031F30'
  name: 'J Navy'
}, {
  hex: '014695'
  name: 'Royal'
}, {
  hex: 'B3D2E7'
  name: 'Light Blue'
}, {
  hex: 'FB4788'
  name: 'Cyber Pink'
}, {
  hex: 'C62047'
  name: 'True Red'
}, {
  hex: '660099'
  name: 'Purple'
}, {
  hex: '70D651'
  name: 'Kiwi'
}, {
  hex: '009A3D'
  name: 'Kelly'
}, {
  hex: '003300'
  name: 'Forest Green'
}, {
  hex: 'FECA3D'
  name: 'Gold'
}, {
  hex: 'FF6600'
  name: 'Burnt Orange'
}, {
  hex: '584130'
  name: 'Chocolate'
}, {
  hex: 'EABDD3'
  name: 'Classic Pink'
}]


exports.CASE_DIMENSIONS =
  width: 4
  height: 6

exports.MUG_DIMENSIONS =
  width: 8.36
  height: 3.48



exports.ARTWORK_DESIGN_PLACEMENT = ['center-small', 'center-medium', 'center-large', 'center-full', 'bottom']

exports.DTG_REJECT_WARNING_THRESHOLD = 2

exports.PRETREAT_MANAGER =
  deleteValue: 0
  min: 5
  max: 100

exports.GARMENT_SINGLE_SIZE_IDENTIFIERS = ['bagedge-canvas-promo-tote']

exports.SUB_USER_PERMISSION =
  shop: 'place orders'
  billing: 'view or perform billing related functionalities'
  order: 'view order history page'
  claim: 'view or perform claims related functionality'
  view: 'view all order, designs, invoices of parent user'

exports.INVENTORY_RACK_LAYOUTS =
  PRIME_VARIABLE:
    type: 'prime-inventory'
    name: 'Prime Inventory'
    size: Number.MAX_VALUE
    locations: ['A1', 'A2', 'A3', 'A4', 'A5', 'A6',
                'B1', 'B2', 'B3', 'B4', 'B5', 'B6',
                'C1', 'C2', 'C3', 'C4', 'C5', 'C6',
                'D1', 'D2', 'D3', 'D4', 'D5', 'D6',
                'E1', 'E2', 'E3', 'E4', 'E5', 'E6',
                'F1', 'F2', 'F3', 'F4', 'F5', 'F6',
                '1A', '2A', '3A', '4A', '5A', '6A',
                '1B', '2B', '3B', '4B', '5B', '6B',
                '1C', '2C', '3C', '4C', '5C', '6C',
                '1D', '2D', '3D', '4D', '5D', '6D',
                '1E', '2E', '3E', '4E', '5E', '6E',
                '1F', '2F', '3F', '4F', '5F', '6F']

  PRETREATED_PRIME_VARIABLE:
    type: 'pretreated-prime-inventory'
    name: 'Prime Inventory - Pretreated'
    size: Number.MAX_VALUE
    locations: ['A1', 'A2', 'A3', 'A4', 'A5', 'A6',
                'B1', 'B2', 'B3', 'B4', 'B5', 'B6',
                'C1', 'C2', 'C3', 'C4', 'C5', 'C6',
                'D1', 'D2', 'D3', 'D4', 'D5', 'D6',
                'E1', 'E2', 'E3', 'E4', 'E5', 'E6',
                'F1', 'F2', 'F3', 'F4', 'F5', 'F6',
                '1A', '2A', '3A', '4A', '5A', '6A',
                '1B', '2B', '3B', '4B', '5B', '6B',
                '1C', '2C', '3C', '4C', '5C', '6C',
                '1D', '2D', '3D', '4D', '5D', '6D',
                '1E', '2E', '3E', '4E', '5E', '6E',
                '1F', '2F', '3F', '4F', '5F', '6F']

  SUPPLEMENTARY_VARIABLE:
    type: 'supplementary-inventory'
    name: 'Supplementary Inventory'
    size: Number.MAX_VALUE
    locations: ['A1', 'A2', 'A3', 'A4', 'A5', 'A6',
                'B1', 'B2', 'B3', 'B4', 'B5', 'B6',
                'C1', 'C2', 'C3', 'C4', 'C5', 'C6',
                'D1', 'D2', 'D3', 'D4', 'D5', 'D6',
                'E1', 'E2', 'E3', 'E4', 'E5', 'E6',
                'F1', 'F2', 'F3', 'F4', 'F5', 'F6',
                '1A', '2A', '3A', '4A', '5A', '6A',
                '1B', '2B', '3B', '4B', '5B', '6B',
                '1C', '2C', '3C', '4C', '5C', '6C',
                '1D', '2D', '3D', '4D', '5D', '6D',
                '1E', '2E', '3E', '4E', '5E', '6E',
                '1F', '2F', '3F', '4F', '5F', '6F']

exports.SHIPMENT_OVERFLOW_MAX = 6
exports.SHIPMENT_OVERFLOW_MIN = 2

exports.RACK_LAYOUTS =
  DTG_LAYOUT:
    type: 'storage'
    name: 'DTG'
    unmarshalled:
      size: 10.24
      locations: ["31", "32", "33"]
    marshalled:
      size: 8
      locations: int.toString() for int in [1..30]

  MARSHAL_LAYOUT:
    type: 'marshal'
    name: 'Marshalling'
    unmarshalled:
      size: 0
      locations: []
    marshalled:
      size: 8
      itemLimit: 6
      locations: int.toString() for int in [1..72]

  BULK_MARSHAL_LAYOUT:
    type: 'marshal'
    name: 'Bulk Marshalling'
    bulk: true
    unmarshalled:
      size: 0
      locations: []
    marshalled:
      size: 24
      itemLimit: 24
      locations: int.toString() for int in [1..24]

  BULK_MARSHAL_LAYOUT_V2:
    type: 'marshal'
    name: 'Bulk Marshalling V2 (18 bins)'
    bulk: true
    unmarshalled:
      size: 0
      locations: []
    marshalled:
      size: 18
      itemLimit: 24
      locations: int.toString() for int in [1..18]

  MEGA_MARSHAL_LAYOUT:
    type: 'marshal'
    name: 'Mega Marshalling'
    mega: true
    unmarshalled:
      size: 0
      locations: []
    marshalled:
      size: 100
      itemLimit: 72
      locations: int.toString() for int in [1..6]

  PACKAGE_MARSHAL_LAYOUT:
    type: 'marshal'
    name: 'Bad address bulk Marshalling'
    package: true
    unmarshalled:
      size: 0
      locations: []
    marshalled:
      size: 10
      locations: int.toString() for int in [1..24]

  MEGARACK_LAYOUT:
    type: 'storage'
    name: 'Megarack'
    unmarshalled:
      size: 38.4
      locations: int.toString() for int in [217..220]
    marshalled:
      size: 3.6
      locations: int.toString() for int in [1..216]

  SCAN_LAYOUT:
    type: 'dtg-sort'
    name: 'DTG Receiving'
    unmarshalled:
      size: 24
      locations: int.toString() for int in [1..6]
    marshalled:
      size: 1
      locations: []

  SCREENPRINT_SORT_LAYOUT:
    type: 'screenprint-sort'
    name: 'Screenprint Receiving'
    unmarshalled:
      size: 24
      locations: int.toString() for int in [1..12]
    marshalled:
      size: 1
      locations: []

  INVENTORY_LAYOUT:
    type: 'marshal-sort'
    name: '6x7 Screenprint Inventory'
    unmarshalled:
      size: 24
      locations: ['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7',
                  'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7',
                  'C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7',
                  'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'D7',
                  'E1', 'E2', 'E3', 'E4', 'E5', 'E6', 'E7',
                  'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7']
    marshalled:
      size: 1
      locations: []

  INVENTORY_LAYOUT_5x4:
    type: 'marshal-sort'
    name: '5x4 Screenprint Inventory'
    unmarshalled:
      size: 24
      locations: ['A1', 'A2', 'A3', 'A4',
                  'B1', 'B2', 'B3', 'B4',
                  'C1', 'C2', 'C3', 'C4',
                  'D1', 'D2', 'D3', 'D4',
                  'E1', 'E2', 'E3', 'E4']
    marshalled:
      size: 1
      locations: []

  INVENTORY_LAYOUT_5x7:
    type: 'marshal-sort'
    name: '5x7 Screenprint Inventory'
    unmarshalled:
      size: 24
      locations: ['1A', '1B', '1C', '1D', '1E',
                 '2A', '2B', '2C', '2D', '2E',
                 '3A', '3B', '3C', '3D', '3E',
                 '4A', '4B', '4C', '4D', '4E',
                 '5A', '5B', '5C', '5D', '5E',
                 '6A', '6B', '6C', '6D', '6E',
                 '7A', '7B', '7C', '7D', '7E']
    marshalled:
      size: 1
      locations: []

  INDY_INVENTORY_LAYOUT:
    type: 'marshal-sort'
    name: '5x5 Screenprint Inventory'
    unmarshalled:
      size: 24
      locations: ['A1', 'A2', 'A3', 'A4', 'A5'
                  'B1', 'B2', 'B3', 'B4', 'B5'
                  'C1', 'C2', 'C3', 'C4', 'C5'
                  'D1', 'D2', 'D3', 'D4', 'D5'
                  'E1', 'E2', 'E3', 'E4', 'E5'
                  'F1', 'F2', 'F3', 'F4', 'F5'
                  'G1', 'G2', 'G3', 'G4', 'G5'
                  'H1', 'H2', 'H3', 'H4', 'H5'
                  'I1', 'I2', 'I3', 'I4', 'I5'
                  'J1', 'J2', 'J3', 'J4', 'J5']
    marshalled:
      size: 1
      locations: []

  MANUAL_P9_STORE_LAYOUT:
    type: 'manual-order-store'
    name: 'Manual P9 Order Store'
    unmarshalled:
      size: 100000
      locations: [1..6].map (bin) -> bin.toString()
    marshalled:
      size: 1
      locations: []

  FLOATING_LAYOUT:
    type: 'marshal-sort'
    name: 'Floating Screenprint Inventory'
    unmarshalled:
      size: 100000000
      locations: ['X1', 'X2', 'X3', 'X4', 'X5', 'X6', 'X7',
                  'Y1', 'Y2', 'Y3', 'Y4', 'Y5', 'Y6', 'Y7',
                  'Z1', 'Z2', 'Z3', 'Z4', 'Z5', 'Z6', 'Z7']
    marshalled:
      size: 1
      locations: []

  FLOATING_LAYOUT_1x5:
    type: 'marshal-sort'
    name: '1x5 Floating Screenprint Inventory'
    unmarshalled:
      size: 100000000
      locations: ['X1', 'X2', 'X3', 'X4', 'X5']

    marshalled:
      size: 1
      locations: []

  OVERFLOW_SORT_LAYOUT:
    type: 'overflow-sort'
    name: 'Overflow Sort Gaylord'
    unmarshalled:
      size: 100000000
      locations: [1..800].map (bin) -> bin.toString()
    marshalled:
      size: 1
      locations: []

  CUSTOMIZATION_OVERFLOW_SORT_LAYOUT:
    type: 'overflow-sort-custom'
    name: 'Overflow Sort Customization Gaylord'
    unmarshalled:
      size: 100000000
      locations: [1..800].map (bin) -> bin.toString()
    marshalled:
      size: 1
      locations: []

  PACKAGE_STORAGE_LAYOUT:
    type: 'storage'
    name: 'Infinity Bad address'
    unmarshalled:
      size: 0
      locations: []
    marshalled:
      size: 1000000
      locations: [1..800].map (bin) -> bin.toString()

exports.BOX_RACK_LAYOUTS =
  POST_PRINT_BOXES_LAYOUT_4x4:
    type: 'postprint-box-store'
    name: '4x4 Post Print Boxes'
    locations: ['A1', 'A2', 'A3', 'A4',
                'B1', 'B2', 'B3', 'B4',
                'C1', 'C2', 'C3', 'C4',
                'D1', 'D2', 'D3', 'D4']

  POST_PRINT_BOXES_LAYOUT_1x5:
    type: 'postprint-box-store'
    name: '1x5 Post Print Boxes'
    locations: ['A1', 'A2', 'A3', 'A4', 'A5']

exports.INTERNET_STATUS =
  refreshInterval: 30 * 1000
  timeoutThresholdMS: 5 * 60 * 1000
  signals:
    error:
      url: 'https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/workstation/icons/signal_0.svg'
    one:
      url: 'https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/workstation/icons/signal_1.svg'
      lowerBound: 4000
    two:
      url: 'https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/workstation/icons/signal_2.svg'
      lowerBound: 2000
    three:
      url: 'https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/workstation/icons/signal_3.svg'
      lowerBound: 1000
    four:
      url: 'https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/workstation/icons/signal_4.svg'
      lowerBound: 400
    five:
      url: 'https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/workstation/icons/signal_5.svg'
      lowerBound: 0

exports.GENERIC_PRODUCT_NAMES =
  'fruit-of-the-loom-cotton-t': 'Classic T-Shirt'
  'jerzees-100-cotton-t-shirt': 'Classic T-Shirt'
  'hanes-tagless-t-shirt': 'Classic T-Shirt'
  'hanes-comfort-soft-t-shirt': 'Classic T-Shirt'
  'anvil-fashion-fit-t-shirt': 'Classic T-Shirt'
  'gildan-ultra-cotton-t-shirt': 'Classic T-Shirt'
  'gildan-cotton-t-shirt': 'Classic T-Shirt'
  'american-apparel-t-shirt': 'Premium Fit Mens Tee'
  'next-level-fitted-crew': 'Premium Fit Mens Tee'
  'canvas-unisex-t-shirt': 'Premium Fit Mens Tee'
  'alternative-apparel-basic-crew-t-shirt': 'Premium Fit Tee'
  'fruit-of-the-loom-hd-v-neck-t-shirt': 'V-Neck T-Shirt'
  'fruit-of-the-loom-sofspun-r-v-neck': 'V-Neck T-Shirt'
  'gildan-v-neck-t-shirt': 'V-Neck T-Shirt'
  'anvil-fashion-v-neck-t': 'V-Neck T-Shirt'
  'canvas-v-neck-t-shirt': 'V-Neck T-Shirt'
  'next-level-mens-cotton-v': 'V-Neck T-Shirt'
  'fruit-of-the-loom-ladies-heavy-cotton-t-shirt': 'Ladies T-Shirt'
  'anvil-ladies-mid-scoop-t-shirt': 'Ladies T-Shirt'
  'gildan-ultra-ladies-t-shirt': 'Ladies T-Shirt'
  'gildan-ladies-missy-t-shirt': 'Ladies T-Shirt'
  'hanes-ladies-comfort-soft-t': 'Ladies T-Shirt'
  'american-apparel-girly-t': 'Premium Fit Ladies Tee'
  'next-level-boyfriend-tee': 'Premium Fit Ladies Tee'
  'bella-ladies-favorite-t-shirt': 'Premium Fit Ladies Tee'
  'next-level-ladies-racerback-tank': 'Ladies Flowy Tank'
  'bella-flowy-racerback-tank': 'Ladies Flowy Tank'
  'jerzees-50-50-hoodie': 'Hooded Sweatshirt'
  'gildan-50-50-hoodie': 'Hooded Sweatshirt'
  'hanes-50-50-hoodie': 'Hooded Sweatshirt'
  'gildan-sweatshirt-crew': 'Long Sleeve Tee'
  'jerzees-50-50-fleece-crew': 'Long Sleeve Tee'
  'jerzees-sweatshirt-crew': 'Long Sleeve Tee'
  'hanes-50-50-fleece-crew': 'Long Sleeve Tee'
  'fruit-of-the-loom-long-sleeve': 'Sleeveless Tee'
  'gildan-ultra-cotton-long-sleeve-t-shirt': 'Sleeveless Tee'
  'jerzees-long-sleeve-t': 'Sleeveless Tee'
  'gildan-long-sleeve-t-shirt': 'Sleeveless Tee'
  'jerzees-sleeveless-t-shirt': 'Sleeveless Tee'
  'gildan-sleeveless-t-shirt': 'Sleeveless Tee'
  'fruit-of-the-loom-hd-tank': 'Unisex Tank'
  'gildan-cotton-tank-top': 'Unisex Tank'
  'next-level-mens-jersey-tank': 'Unisex Tank'
  'fruit-of-the-loom-youth-cotton-t': 'Youth T-Shirt'
  'jerzees-hi-densi-t-youth-t': 'Youth T-Shirt'
  'hanes-youth-comfort-soft-t': 'Youth T-Shirt'
  'gildan-youth-ultra-cotton-t': 'Youth T-Shirt'
  'gildan-youth-cotton-t': 'Youth T-Shirt'
  'bagedge-canvas-promo-tote': 'Tote Bag'
  'rabbit-skins-infant-bodysuit': 'Infant Onesie'

exports.RIP_X_PLACEMENT = ['L', 'R', 'C', 'LC', 'RC']

exports.RIP_VERTICAL_PLACEMENT = ['top', 'center', 'bottom']

exports.PLATENS = ['4x4', '4x16', '7x8', '10x12', '14x16', '16x20', 'HAT']

exports.RIP_LOCATIONS = ['BROTHER_CLOUD', 'CLOUD', 'FRESNO', 'SCRANTON', 'INDY', 'DALLAS']

exports.INACTIVE_RIP_LOCATIONS = ['BROTHER_CLOUD', 'FRESNO', 'SCRANTON'] # These will not be automatically created for new rips

exports.EMBR_POSITIONS = ['LC', 'RC', 'CF', 'BC', 'LS', 'RS']

exports.EMBR_LOCATIONS = ['CLOUD', 'INDY']

exports.EMBR_PRICING_RULES =
  numFreeStitches: 10000
  numExtraStitchesPerTier: 1000

exports.AGENT_PERMISSIONS =
  sales:
    claim : true,
    order : true,
    billing : false,
    shop : false
  purchase:
    claim : true,
    order : true,
    billing : true,
    shop : true

exports.SP_MOCKUP_COMPLETION_EXCHANGE = 'sp-mockup-completion'

exports.STORE_CREDIT_TYPE = [
  'promotion'        # Promotional issue
  'claim'            # Order or Item claim
  'check'            # When clients sends a mailed check to SP
  'ach-wire'         # Manual ACH or wire sent to SP, not via our ACH payment system
  'write-off'        # Credit used to offset written off bad debt
  'check-refund'     # When we refund a client through a mailed check, amount negative
  'admin-reversal'   # General purpose remove store credit
  'adfairy-credit'   # AdFairy credit from profit
  'adfairy-payoneer' # AdFairy credit from payoneer
  'adfairy-paypal'   # AdFairy credit from paypal
  'adfairy-discount' # AdFairy credit from discount for tier rewards
  'adlauncher-credit' # AdLauncher credit from profit
  'adlauncher-payoneer' # AdLauncher credit from payoneer
  'adlauncher-paypal' # AdLauncher credit from paypal
  'google-credit'     # Google credit from profit
  'google-payoneer'   # Google credit from payoneer
  'google-paypal'     # Google credit from paypal
  'teechip-cash'      # TeeChip Cash credit
  'sp-cash'           # SP Cash
]

exports.DEBIT_TYPE = DEBIT_TYPE = {
  order: 'order'                                    # Initial payment
  adjustment: 'adjustment'                          # Additional adjustment after initial order
  rollback: 'rollback'                              # For rollback debit - inverse charge invoice
  refund: 'refund'                                  # Refund against initial payment or adjustment
  # AdFairy
  adFairyCashAdjustment: 'adfairy-cash-adjustment'  # AFC: Applied for safe reset in AFC balance
  # sl-retail seller payout
  affiliateCommission: 'affiliate-commission'         # Profit for affiliate (seller)
  fee: 'fee'
  # Deprecated
  preSaleRefund: 'pre-sale-refund'                  # DEPRECATED
  postSaleRefund: 'post-sale-refund'                # DEPRECATED
  claim:'claim'                                     # DEPRECATED Refund made through claims
}

exports.DEBIT_TYPES = _.map(DEBIT_TYPE)

exports.NONSPUSERSEMAILS = [
  'support@teechip.com', 'admin@scalablelicensing.com',
  'doug@shirts.io', 'aanderson@alphabroder.com', 'decosupportsp@alphabroder.com',
  /ooshirts\.com/i, /scalablepress\.com/i, /teechip\.com/i, /inkpop\.com/i
  ## 'admin@thefanrock.com', ''
]

exports.DTG_RIP_PROFILE_SETTING = 'dtg-rip-profile'

exports.DTG_LEGACY_RIP_GROUP = 'cadlink5'

exports.BLACKLIST_KEYWORD_LEVELS = ['IGNORED', 'MEDIUM', 'HIGH']



// WEBPACK FOOTER //
// ./~/oo-config/constants.coffee